export const buildToastSalesFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(name => ({
          value: String(name),
          label: name,
        })),
      },
    ],
  },
  {
    id: 'match_status',
    label: 'Matching',
    filters: [
      {
        id: 'match_status',
        label: 'Match Status',
        type: 'checkbox',
        options: (filterOptions.match_status_options || []).map(option => ({
          value: String(option.value),
          label: option.label,
        })),
      },
    ],
  },
];
